/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * События воркеров
 */

/**
 * Тип доступности
 */
export enum DeviceAvailabilityTaskAvailabilityType {
  /**
   * Значение не указано
   */
  AVAILABILITY_TYPE_UNKNOWN = "AVAILABILITY_TYPE_UNKNOWN",
  /**
   * Онлайн
   */
  ONLINE = "ONLINE",
  /**
   * Офлайн
   */
  OFFLINE = "OFFLINE",
}
/**
 * Тип доступности
 */
export type DeviceAvailabilityTaskAvailabilityTypeResponseEnum = keyof typeof DeviceAvailabilityTaskAvailabilityType
/**
 * Тип доступности
 */
export type DeviceAvailabilityTaskAvailabilityTypeRequestEnum = Exclude<DeviceAvailabilityTaskAvailabilityTypeResponseEnum, "AVAILABILITY_TYPE_UNKNOWN">;

/**
 * Событие изменения доступности устройства.
 * Очередь bus.watchdog.device_availability
 */
export type DeviceAvailabilityTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Тип доступности
   */
  availabilityType: DeviceAvailabilityTaskAvailabilityTypeRequestEnum
}
/**
 * Событие изменения доступности устройства.
 * Очередь bus.watchdog.device_availability
 */
export type DeviceAvailabilityTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Тип доступности
   */
  availabilityType: DeviceAvailabilityTaskAvailabilityTypeResponseEnum
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Событие изменения доступности устройства.
   * Очередь bus.watchdog.device_availability
   */
  "DeviceAvailabilityTask": {
    "kind": "class",
    "text": "Событие изменения доступности устройства.\nОчередь bus.watchdog.device_availability",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип доступности
       */
      "availabilityType": {
        "type": "DeviceAvailabilityTask.AvailabilityType",
        "text": "Тип доступности",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Тип доступности
   */
  "DeviceAvailabilityTask.AvailabilityType": {
    "kind": "enum",
    "text": "Тип доступности",
    "values": {
      /**
       * Значение не указано
       */
      "AVAILABILITY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Онлайн
       */
      "ONLINE": {
        "i": 1,
        "text": "Онлайн",
      },
      /**
       * Офлайн
       */
      "OFFLINE": {
        "i": 2,
        "text": "Офлайн",
      },
    },
  },
}